import { Link } from 'react-router-dom';

import { Icon } from '../../../components/icon';
import { Badge } from '../../../components/shadcn/badge';
import { TrackingEventsV2 } from '@/analytics/eventsV2';
import { trackCustomEvent } from '@/analytics/Mixpanel';
import { Matter } from '@/api/types/backend-dto-types';
import isPlural from '@/helpers/isPlural';

interface PersonalMatterCardProps {
  matter: Matter;
}

export function PersonalMatterCard({ matter }: PersonalMatterCardProps) {
  return (
    <Link
      to={`/matters/${matter.id}`}
      onClick={() => trackCustomEvent(TrackingEventsV2.ViewPersonalMatter, { matterId: matter.id })}
      className="group animate-in fade-in flex w-full flex-col rounded-md border border-purple-200 shadow-lg/2 duration-150 hover:border-purple-200 hover:shadow-lg/10 hover:shadow-purple-300"
    >
      <div className="flex items-center justify-between gap-3 rounded-t-md border-b border-purple-200 bg-purple-50 p-3 px-4.5">
        <div className="flex min-w-0 flex-1 items-center gap-3 text-base font-medium text-purple-700 duration-150 group-hover:text-purple-800">
          <Icon className="lucide--flask-conical text-purple-400 duration-150 group-hover:text-purple-600" />
          <span className="truncate">{matter.name}</span>

          {matter.code && (
            <span className="flex-shrink-0 rounded-md border border-gray-300 bg-white p-0.5 px-1 pb-0.25 text-xs text-gray-500">
              {matter.code}
            </span>
          )}
        </div>

        <div className="flex-shrink-0 rounded-full bg-purple-50 px-1.5 py-0">
          <Badge className="text-[11px] font-medium text-purple-600">Personal Matter</Badge>
        </div>
      </div>
      <div className="flex grow flex-col">
        <div className="flex grow flex-col rounded-b-md border-t border-purple-50 px-5 py-4 text-gray-700">
          <div className="flex items-end justify-between">
            <div>
              <p className="mb-0.5 flex items-center gap-2 text-purple-500">
                <Icon className="lucide--group text-purple-400" />
                <span className="font-medium">
                  {matter.casesCount ?? 0}{' '}
                  <span className="font-normal">
                    {isPlural({ one: 'subset', more: 'subsets', number: matter.casesCount ?? 0 })}
                  </span>
                </span>
              </p>

              <p className="flex items-center gap-2 text-purple-500">
                <Icon className="lucide--file-text text-purple-400" />
                <span className="font-medium">
                  {matter.docsCount ?? 0}{' '}
                  <span className="font-normal">
                    {isPlural({ one: 'doc', more: 'docs', number: matter.docsCount ?? 0 })}
                  </span>
                </span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </Link>
  );
}
